<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <registrations-crud></registrations-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RegistrationsCrud from './registrations/RegistrationsCrud';

    export default {

        components: {
            RegistrationsCrud
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.registrations'),
                    },
                ]
            }
        },
    }
</script>
